import Loader from "../../../../components/loaders";
import { Button } from "../../../../components";
import Documento from "./Documento";

const View = ({
  loading,
  historico,
  handleDownload,
  loadingExportHistorico,
}) => {
  return (
    <>
      {!!loading && (
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <Loader type={"dots"} color={"brand"} size={50} />
          </div>
        </div>
      )}
      {!loading && (
        <>
          {historico.length === 0 && (
            <div className="flex d-flex flex-column justify-content-center align-items-center">
              <span className="d-block colored-card-text mt-4 color-secondary text-center">
                Nenhum documento encontrado.
              </span>
            </div>
          )}

          <div className="row">
            <div className="col-12">
              <div className="" style={{ minHeight: 100 }}>
                <div className="card-body d-flex flex-column">
                  <div className={"row d-flex align-items-center"}>
                    <div className={"mt-0"}>
                      <div className="card-title-checklist">Documentos</div>
                    </div>
                    <div className={"mt-0 ml-auto"}>
                      <Button
                        label="Download"
                        onClick={handleDownload}
                        loading={!!loadingExportHistorico}
                      />
                    </div>
                  </div>
                  <div className={"row"}>
                    <div className="col-12">
                      <div
                        className={
                          "row mt-0 d-flex align-items-center medium-row texto-dispensar tr-odd"
                        }
                      >
                        <div className="col-sm-12 col-lg-3 mt-sm-2 mt-lg-0">
                          <span>Participante</span>
                        </div>
                        <div className="col-sm-12 col-lg-3 mt-sm-2 mt-lg-0 ">
                          <span>Documento</span>
                        </div>
                        <div className="col-sm-12 col-lg-2 mt-sm-2 mt-lg-0 ">
                          <span>Situação</span>
                        </div>
                        <div className="col-sm-12 col-lg-1 mt-sm-2 mt-lg-0 ">
                          <span>Criação</span>
                        </div>
                        <div className="col-sm-12 col-lg-2 mt-sm-2 mt-lg-0 text-center">
                          <span>Indexação</span>
                        </div>
                        <div className="col-sm-12 col-lg-1 mt-sm-2 mt-lg-0 ">
                          <span>Análise</span>
                        </div>
                      </div>
                      {historico.map((d, index) => (
                        <Documento key={d.id} documento={d} index={index} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default View;
